// Components List
export const motionComponents = [
  "MOVE",
  "MOVE_Y",
  "TURN_CLOCKWISE",
  "TURN_ANTI_CLOCKWISE",
  "GOTO_XY",
];

export const looksComponents = [
  "SAY_MESSAGE",
  "SAY_MESSAGE_WITH_TIMER",
  "THINK",
  "THINK_TIMER",
  "HIDE_MESSAGE",
  "SIZE",
  "SHOW",
  "HIDE",
];

export const eventsComponents = ["BROADCAST"];

export const controlComponents = ["WAIT", "REPEAT"];
